<template>
  <!-- 点击新增发票模板 -->
  <div style="padding:15px;padding-top:0;">
    <el-table :data="dataTempate"
              style="width: 100%">
      <el-table-column label="发票内容">
        <template slot-scope="scope">
          <div v-if="scope.$index==0">
            <el-select v-model="scope.row.invoiceContentId"
                       @change="selectContent(inde,index,scope.$index,$event)"
                       placeholder="请选择发票内容">
              <el-option v-for="item in scope.row.contentList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div>
            {{scope.row.invoiceContent}}
          </div>

        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { ref, reactive, toRefs, onMounted } from '@vue/composition-api'
export default {
  props: {
    dataTempate: {

    }
  },
  setup (props, { root }) {
    const age = ref(props.dataTempate)
    const selectContent = () => {
      console.log('2222')
    }
    // const data = reactive({
    //   addInvoiceTempate: {
    //     invoiceContentId: null,
    //     invoiceContent: null,
    //     invoiceAmount: null,
    //     count: null,
    //     price: null,
    //   }
    // })
    return {
      age, selectContent
    },
      onMounted(() => {
        console.log(age)
      })
  }
}

</script>